import React from "react";
import { Globe2 } from "lucide-react";
import { CURRENCIES } from "@/lib/currency";

export const CurrencyPicker = ({ currency, onChange, className = "" }) => (
  <label
    className={`inline-flex items-center gap-1.5 rounded-full border border-line bg-bg-elevated px-3 py-1.5 text-xs font-mono uppercase tracking-wider text-ink-secondary hover:border-brand-amber/50 transition cursor-pointer ${className}`}
    data-testid="currency-picker"
    title="Display currency — checkout is billed in USD"
  >
    <Globe2 className="h-3.5 w-3.5 text-brand-amber" />
    <select
      value={currency}
      onChange={(e) => onChange(e.target.value)}
      data-testid="currency-picker-select"
      className="bg-transparent outline-none cursor-pointer text-ink-primary appearance-none pr-1 max-w-[110px] sm:max-w-none"
    >
      {CURRENCIES.map((c) => (
        <option key={c.code} value={c.code} className="bg-bg-surface text-ink-primary">
          {c.code} — {c.name}
        </option>
      ))}
    </select>
  </label>
);
